import { render } from "./ClientSelect.vue?vue&type=template&id=15d97c4d"
import script from "./ClientSelect.vue?vue&type=script&lang=js"
export * from "./ClientSelect.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Custom/ClientSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15d97c4d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15d97c4d', __exports__)) {
    console.log('reload')
    api.reload('15d97c4d', __exports__)
  }
  
  module.hot.accept("./ClientSelect.vue?vue&type=template&id=15d97c4d", () => {
    console.log('re-render')
    api.rerender('15d97c4d', render)
  })

}


export default __exports__